import type { ReactNode } from "react";

export interface BillingDetailsContainerProps {
  children: ReactNode;
}

export const BillingDetailsContainer = ({
  children,
}: BillingDetailsContainerProps) => (
  <div className="bg-primary border-primary rounded-2xl border p-6">
    {children}
  </div>
);
